import React, { useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const ModalImport = ({ toggle, modal, title, body, buttonLabel, onClick, centered, color }) => {

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} centered={centered}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          {body}
        </ModalBody>
        <ModalFooter>
          <Button color={color ? color : "primary"} onClick={onClick}>
            {buttonLabel}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ModalImport